<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>绑定城市</h3>
          </div>

        </div>
        <div class="div-step">
          <el-steps :active="3" align-center>
            <el-step title="添加决策模型"></el-step>
            <el-step title="关联环境模型"></el-step>
            <el-step title="关联生长模型"></el-step>
            <el-step title="绑定城市"></el-step>
            <el-step title="绑定摄像头"></el-step>
            <el-step title="添加设备调控"></el-step>
            <el-step title="添加大棚告警"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <div class="info-content-container">
          <div class="table_content1" style="margin-top: 10px">
            <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="120px" class="demo-ruleForm">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="所在城市：" prop="areaArr">
                    <el-cascader v-model="ruleForm.areaArr" placeholder="请选择所在城市" :options="areaData" ref="cascaderAddr"
                      :props="{ value: 'label', label: 'label' }" clearable @change="areaChange">
                    </el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="城市编码：" prop="code">
                    <el-input v-model="ruleForm.code" placeholder="请输入城市编码" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="城市经度：" prop="longitude">
                    <el-input v-model="ruleForm.longitude" placeholder="请输入城市经度" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="城市纬度：" prop="dimension">
                    <el-input v-model="ruleForm.dimension" placeholder="请输入城市纬度" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="display: flex;justify-content: space-around;">
              <div></div>
              <div class="pagination-container" style="margin-left: 12rem;">
                <div class="page"></div>
                <div slot="footer" class="div-footer">
                  <el-button type="primary" @click="handleSave">保 存</el-button>
                </div>
              </div>

              <div style="margin-top: 1.2rem;">
                <el-button type="primary" @click="handlePrev">上一步</el-button>
                <el-button type="primary" @click="handleNext">下一步</el-button>
                <el-button type="primary" @click="handleReturn">返回决策模型</el-button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { regionData } from "element-china-area-data";
export default {
  data() {
    return {
      ruleForm: {
        // 添加编辑弹窗表单字段
        decisionId: "",
        dimension: "",
        longitude: "",
        code: "",
        name: "",
        areaArr: [],
        area: "",
      },
      rules: {
        // 添加编辑弹窗表单规则
        areaArr: [
          {
            required: true,
            message: "请选择所在城市",
            trigger: "change",
          },
        ],
      },
      modelEvnArray: [], // 大棚名称数组
      areaData: regionData,
    };
  },
  created() {
    this.ruleForm.decisionId = this.$route.query.decisionId;

    // 获取详情
    this.getDetail();
  },
  methods: {
    // 获取详情
    getDetail() {
      if (!this.ruleForm.decisionId || this.ruleForm.decisionId == "") {
        return;
      }

      this.$api.growthModel
        .getLocationByDecision({ id: this.ruleForm.decisionId })
        .then((res) => {
          if (res.code == 200) {
            this.ruleForm.area = res.data.area;
            this.ruleForm.code = res.data.code;
            this.ruleForm.name = res.data.name;
            this.ruleForm.dimension = res.data.dimension;
            this.ruleForm.longitude = res.data.longitude;
            this.ruleForm.areaArr =
              res.data.area != undefined ? res.data.area.split(" / ") : [];
          }
        });
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel.bandingCity(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
            }
          });
        }
      });
    },
    // 城市下拉切换
    areaChange() {
      this.ruleForm.area = "";
      this.ruleForm.code = "";
      this.ruleForm.name = "";
      this.ruleForm.dimension = "";
      this.ruleForm.longitude = "";

      if (this.ruleForm.areaArr.length == 3) {
        let name = this.ruleForm.areaArr[2];
        if (name == "市辖区") {
          name = this.ruleForm.areaArr[1];
        }
        this.ruleForm.area = this.ruleForm.areaArr.join(" / ");
        this.$api.growthModel.getCity({ name: name }).then((res) => {
          if (res.code == 200 && res.data.length > 0) {
            this.ruleForm.code = res.data[0].code;
            this.ruleForm.name = res.data[0].name;
            this.ruleForm.dimension = res.data[0].dimension;
            this.ruleForm.longitude = res.data[0].longitude;
          } else {
            this.$message({
              type: "error",
              message: "该城市数据不全，请更换城市",
            });
            this.ruleForm.areaArr = [];
          }
        });
      }
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {},
      });
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `relationGrowthModel`,
        query: {
          decisionId: this.$route.query.decisionId,
          groupId: this.$route.query.groupId,
        },
      });
    },
    // 下一步
    handleNext() {
      this.$router.push({
        name: `bandingVideo`,
        query: {
          decisionId: this.$route.query.decisionId,
          groupId: this.$route.query.groupId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 10px;
    margin-right: 10px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 600px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }

  .add-more {
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    color: #256bff;
    cursor: pointer;
  }
}
</style>